import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { MessagesService } from '../../services/messages.service';
import { DetailedMessageDTO } from '../../model/admin-dto';
import { PageTitleComponent } from '../../ui/page-title/page-title.component';

@Component({
  selector: 'rqa-messages-list',
  templateUrl: './messages-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    TranslateModule,
    ButtonModule,
    TooltipModule,
    PageTitleComponent
  ],
  providers: [MessagesService, DialogService],
  standalone: true,
  styles: [
    `
      .message-details{
          word-break: break-word;
      }
    `
  ]
})
export class MessagesListComponent implements OnInit {
  private messagesService = inject(MessagesService);
  messages: DetailedMessageDTO[] = [];

  ngOnInit(): void {
    this.getMessages();
  }

  getMessages() {
    this.messagesService.getSentMessages().subscribe((value) => {
      this.messages = value;
    });
  }

  search() {
    this.getMessages();
  }
}
